import type { SettingsChoice } from '@/shared/stores/settings/types';

export const commonChoices: SettingsChoice[] = [
    { id: 'accountTag', name: 'Account tag' },
    { id: 'characterLevel', name: 'Character level' },
    { id: 'characterName', name: 'Character name' },
    { id: 'characterIconClass', name: 'Icon - Class' },
    { id: 'characterIconRace', name: 'Icon - Race' },
    { id: 'characterIconSpec', name: 'Icon - Specialization' },
    { id: 'realmName', name: 'Realm name' },
];

export const homeChoices: SettingsChoice[] = [
    { id: 'bagSpace', name: 'Bag Space' },
    { id: 'covenant', name: 'Covenant' },
    { id: 'currencies', name: 'Currencies' },
    { id: 'gear', name: 'Gear' },
    { id: 'gold', name: 'Gold' },
    { id: 'goldWorldQuests', name: 'Gold World Quests' },
    { id: 'guild', name: 'Guild' },
    { id: 'bestItemLevel', name: 'Item Level - Best' },
    { id: 'itemLevel', name: 'Item Level - Equipped' },
    { id: 'items', name: 'Items' },
    { id: 'lastSeenAddon', name: 'Last Seen - Addon' },
    { id: 'currentLocation', name: 'Location - Current' },
    { id: 'hearthLocation', name: 'Location - Hearth' },
    { id: 'lockouts', name: 'Lockouts' },
    { id: 'keystone', name: 'Mythic+ keystone' },
    { id: 'mythicPlusScore', name: 'Mythic+ score' },
    { id: 'playedTime', name: 'Played time' },
    { id: 'professions', name: 'Professions - Primary' },
    { id: 'professionsV2', name: 'Professions - Primary (V2)' },
    { id: 'professionsSecondary', name: 'Professions - Secondary' },
    { id: 'professionConcentration', name: 'Profession Concentration [Mid]' },
    { id: 'professionConcentrationTWW', name: 'Profession Concentration [TWW]' },
    { id: 'professionConcentrationDF', name: 'Profession Concentration [DF]' },
    { id: 'professionCooldowns', name: 'Profession Cooldowns' },
    { id: 'professionEquipment', name: 'Profession Equipment ' },
    { id: 'professionMoxie', name: 'Profession Moxie' },
    { id: 'professionWorkOrders', name: 'Profession Work Orders' },
    { id: 'progress', name: 'Progress' },
    { id: 'restedExperience', name: 'Rested XP' },
    { id: 'statsSpeed', name: 'Stats - Movement Speed' },
    { id: 'statusIcons', name: 'Status icons' },
    { id: 'tasks', name: 'Tasks' },
    { id: 'vaultMythicPlus', name: 'Vault - Dungeon' },
    { id: 'vaultRaid', name: 'Vault - Raid' },
    { id: 'vaultWorld', name: 'Vault - World' },
];

export const removedHomeChoices = new Set(['callings', 'emissariesBfa', 'emissariesLegion']);
